module.exports = __webpack_public_path__ + "static/img/2.4fce9b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/2.jpg
// module id = hCQU
// module chunks = 1